module.exports = vendor_ed037a328a0cdc507472;


//////////////////
// WEBPACK FOOTER
// external "vendor_ed037a328a0cdc507472"
// module id = 5
// module chunks = 0 1